import styled from "styled-components";

export const ContainerTable = styled.div<{
  children: any;
}>`
  margin-top: 20px;
`;

export const DivButtonExportFile = styled.div<{
  children: any;
}>`
  display: flex !important;
  justify-content: flex-end;
  margin-bottom: 5px;
`;